import styled from "styled-components";

export const Sidebar = styled.aside`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 11rem;
  // background-color: #0072c6;
  color: white !important;
  padding: 1rem 0 2rem 0;
  transition: all 0.5s ease;
  background: #000428;
`;

export const NavContainer = styled.nav`
  display: flex;
  flex-direction: column;
  space-between: 1.5rem;
  text-align: center;
  width: 80%;
`;

export const NavLink = styled.div`
  font-size: 1.125rem;
  font-weight: 400;
  margin-bottom: 1.5rem;
  color: white !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const Container = styled.div`
  width: 100vw;
  height: calc(100vh - 100px);
  display: flex;
  box-sizing: border-box;
  background-color: #e1e3ea;
  justify-content: center;
  position: fixed;
  top: 120px;
  right: 0;
  left: 0;
  // padding: 0 10%;
  gap: 1.6rem;
`;

export const ContainerViewer = styled.div`
  height: calc(100vh - 65px);
  display: flex;
  box-sizing: border-box;
  background-color: #fff;
  justify-content: center;
`;

export const Section = styled.div`
  // flex: ${(props) => props.$flex || 1};
  width: 550px;
  position: relative;
  height: 100%;
`;

export const SectionContent = styled.div`
  height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  border: 1px solid rgb(var(--mui-mainColorChannels-light) / 0.12);
  margin-top: 1.5rem;
`;

export const SectionText = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  color: #374151;
  width: 100%;
  text-align: left;
  margin-left: 30%;
`;

export const BlurrySeparator = styled.div`
  width: 1px;
  background: linear-gradient(to bottom, transparent, #d1d5db, transparent);
  backdrop-filter: blur(4px);
`;

export const Wrapper = styled.div`
  display: flex;
`;

export const ContainerForInner = styled.div`
  display: flex;
  width: 100%;
  height: calc(100vwh - 40px);
  flex-direction: column;
  overflow: hidden;
  padding: 0 10px 10px 10px;
  flex-wrap: wrap;
  width: 100%;
  height: 80%;
  align-items: center;
  justify-content: center;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  height: 50px;
  width: 100%;
  padding: 5px;
  margin: 5px;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const MainArea = styled.div`
  display: flex;
  flex-dirction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 5px;
  margin: 5px;
`;
